<template lang="pug">
  .card
    header.card-header
      p.card-header-title
        slot(name="title")
          | Adjunta una imagen o pdf
      a.card-header-icon
        span.icon
          slot(name="topIcon")
            i.fa.fa-file-image-o
    .card-content
      .content
        form.upload-container.w-64(enctype="multipart/form-data", @submit.prevent="uploadFile")
          p.has-text-left
            span
              slot(name="explanation")
                | Adjunta una imagen o pdf
          .dropzone(
            id="dropzone"
            v-if="!filename",
            @click='select'
          )
            transition(name="fade-quick")
              .overlay(v-show="$upload.dropzone(name).active")
                span Suelta el archivo para cargarlo
            //- .upload-progress(v-if='$upload.meta(name).status == "sending"')
            //-   span {{$upload.meta(name).percentComplete}}%
            span.icon.is-large
              i.fa.fa-cloud-upload
            span.margin-bottom-10
              slot(name="dropzoneDescription")
                | Arrastra el archivo o imagen que desees cargar o dale click al recuadro para buscar en tus archivos

          .error(v-if="$upload.errors(name).length > 0")
            | {{ $upload.errors(name)[0].msg }}

          transition(name="fade")
            .uploaded-file(v-if="filename")
              template()
                h5.file-name.mb-4.text-purple-500.font-bold {{ filename }}
              .buttons-container
                //- template(v-if="!isSaving")
                template
                  button.button.flex-1.margin-left-5.is-primary(
                    type="submit"
                  )
                    i.fa.fa-spinner.fa-spin(v-if="isSaving")
                    template(v-else)
                      span.icon.is-small
                        i.fa.fa-save.fa-fw.fa-lg
                      span Guardar archivo
                //- template(v-else)
                //-   button.button.flex-1.margin-left-5.is-primary.is-loading.is-disabled(
                //-   )
                //-     span Guardando

    footer.card-footer
      a.card-footer-item(
        @click="close"
      ) Cancelar
</template>

<script>
  import { apiUploadWithParams, notify } from '../util/general'

  export default {
    name: 'upload_component',
    props: ['url', 'name', 'isSaved', 'observations', 'folder', 'onlyPdf', 'onlyImg', 'onlyPng', 'onlyWord'],
    data () {
      return {
        fileSubido: {},
        apiRoute: process.env.API_ROUTE,
        filename: '',
        isSaving: false,
        extensions: ['pdf', 'png', 'jpg', 'docx', 'doc',  'xlsx', 'pptx', 'txt', 'zip', 'pbix', 'pbit', 'pbip', 'pbir']
      }
    },
    computed: {
      _meta () {
        let vm = this
        return this.$upload.meta(vm.name);
      },
      _file () {
        let vm = this
        return vm.$upload.file(vm.name);
      }
    },
    mounted () {
      var vm = this
      vm.create()
      vm.$forceUpdate()
    },
    beforeDestroy () {
      let vm = this
      vm.$upload.off(vm.name);
    },
    methods: {
      create () {
        let vm = this
        if (vm.onlyPdf) {
          vm.extensions = ['pdf']
        } else if (vm.onlyImg) {
          vm.extensions = ['png', 'jpg', 'jpeg', 'webp']
        } else if (vm.onlyPng) {
          vm.extensions = ['png']
        } else if (vm.onlyWord) {
          vm.extensions = ['docx', 'doc']
        }

        vm.$upload.on(vm.name, {
          extensions    : vm.extensions,
          maxSizePerFile: 1024 * 1024 * 5,
          dropzoneId: 'dropzone',
          startOnSelect: false,
          http: (data) => {
          },
          onSelect: (files, res) => {
            vm.fileSubido = vm._file.$file
            vm.filename   = vm._file.$file.name
            let extension = vm.filename.substring(vm.filename.lastIndexOf('.') + 1, vm.filename.length)
            if (!vm.extensions.includes(extension)) {
              vm.$upload.reset(vm.name)
              vm.fileSubido = {}
              vm.filename   = ''
              notify(vm, 'error', 'Error', `Solo se permiten archivos ${vm.extensions.join(', ')}`)
            }
          },
          onProgress (file, res) {
          },
          onSuccess: (file, res) => {
            this.file = res.data.data
          },
          onError: (file, res) => {
          },
          onEnd (files, res) {
          }
        })
      },
      select () {
        let vm = this
        vm.$upload.select(vm.name);
      },
      start () {
        let vm = this
        vm.$upload.start(vm.name);
      },
      reset () {
        let vm = this
        this.$upload.reset(vm.name);
      },
      limpiar () {
        let vm = this
        vm.fileSubido = {}
        vm.filename   = ''
        this.$upload.reset(vm.name)
      },
      update () {
        var vm = this
        vm.$upload.reset(vm.name)
      },
      uploadClipBoard (e) {
        let vm = this
        if (e.clipboardData && e.clipboardData.items) {
          var ele = e.clipboardData.items;
          for (var i = 0; i < ele.length; ++i) {
            if (ele[i].kind === 'file' && ele[i].type.indexOf('image/') !== -1) {
              var blob = ele[i].getAsFile();
              vm.$upload.reset(vm.name)
              vm.fileSubido = blob
              vm.filename   = blob.name
              vm.update()
            }
          }
        } else {
          return;
        }
      },
      uploadFile () {
        var vm = this
        if (vm.isSaving) return
        vm.isSaving = true
        if (vm.$upload.errors(vm.name).length > 0) {
          notify(vm, 'error', 'Error', 'Por favor corrija los errores del archivo adjunto')
          return
        }

        var fd = new FormData()
        fd.append('file', vm._file.$file)
        var params = {
          carpeta: vm.folder,
          usuario: localStorage.getItem('usuario')
        }

        apiUploadWithParams(vm, `/upload`, fd, params,
          function (res) {
            vm.limpiar()
            vm.update()
            vm.$emit('save', res)
          },
          function (err) {
            console.error(err)
          },
          function () {
            vm.isSaving = false
          }
        )
      },
      close () {
        var vm = this
        vm.$emit('close')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  .download-container
    padding 13px 10px 0px 10px

  .upload-container
    padding 13px 10px 0px 10px
    .dropzone
      width 100%
      height fit-scontent
      border: 4px dashed;
      position relative
      border-radius 10px
      border-color #00d1b2;
      margin 10px 0px
      display flex
      flex-direction column
      justify-content center
      align-items center
      cursor pointer
      padding: 10px;

      .overlay
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color rgba(10,10,10,.3)
        display flex
        justify-content center
        align-items center
        color #fff
        font-size 28px

      .upload-progress
        position absolute
        top 0
        right 0

      .icon
        display: block;
        margin-top: 10px;

    .uploaded-file
      display flex
      flex-direction column
      justify-content center
      align-items center
      button
        margin-top 5px


    .error
      color red

    .observations
      margin-top 10px
      display flex
      flex-direction column
      align-items center
      border 1px solid red
      padding 10px
      background-color #fde0e0
      p
        font-size 20px
        margin-bottom 0
      ul
        list-style-type none
        text-align left
        font-weight bold
        .error
          color red
        .warning
          color #4831ff


</style>



// WEBPACK FOOTER //
// Component_Upload_Image.vue?4f9a6b27